import React from 'react';
import TeacherMasterLayout from '../../../layouts/gcstaff/staffmasterlayout/TeacherMasterLayout';
import TeacherReviewPage from '../../../subsreens/gcstaff/teacherReviewpage/TeacherReviewPage';




const  TeacherReview= () => {
    return(
       <TeacherMasterLayout>
       <TeacherReviewPage/>
       </TeacherMasterLayout>
    )
}

export default TeacherReview;